import { Injectable, computed, inject, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { ApiMethodService } from '../../tools/services/api/method-api/apiMethod.service';
import { VAT_FALLBACK_RATE_PERCENT, formatVatRate } from '../utils/vat-amount.util';

export interface VatSettingDto {
  ratePercent: number;
  effectiveFrom?: string | null;
}

/** อัตรา VAT ปัจจุบันจาก API (city_parking_vat_rate) — ห้าม hardcode 7% ในหน้าจอ */
@Injectable({ providedIn: 'root' })
export class VatSettingService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private loaded = false;
  private loading = false;

  readonly ratePercent = signal<number>(VAT_FALLBACK_RATE_PERCENT);
  readonly rateLabel = computed(() => formatVatRate(this.ratePercent()));

  constructor() {
    this.ensureLoaded();
  }

  /** เรียกซ้ำได้ — โหลดครั้งเดียวหลังมี token */
  ensureLoaded(): void {
    if (this.loaded || this.loading) return;
    const token = this.cookieService.get('token');
    if (!token) return;

    this.loading = true;
    this.apiMethodService
      .request<VatSettingDto>('/Backoffice/getVatSetting', 'GET', this.baseUrl, {
        isConsoleLog: false,
        labelLog: 'getVatSetting',
        token,
        headerOnly: false,
      })
      .subscribe({
        next: (res) => {
          const rate = Number(res?.ratePercent);
          if (Number.isFinite(rate) && rate >= 0) {
            this.ratePercent.set(rate);
            this.loaded = true;
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }
}
